/* PWL: keep internal links in rich text (descriptions, pages, articles) inside the current market/language root.
   e.g. /pages/certyfikaty or /de/pages/certyfikaty -> /de-de/pages/certyfikaty on purewhitelume.com/de-de. */
(function () {
  var s = document.currentScript;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || (s && s.getAttribute('data-root')) || '/';
  if (root.charAt(root.length - 1) !== '/') root += '/';
  var SCOPE = '.rte, .product__description, .pwl-dt__c, .article-template__content, .page-content';
  var ALLOW = /^\/(products|collections|pages|blogs|policies|search)(\/|$|\?|#)/;
  var LOCALE = /^\/[a-z]{2,3}(-[a-z0-9]{2,4})?(?=\/)/i;
  function fix(a) {
    var h = a.getAttribute('href');
    if (!h || h.charAt(0) !== '/' || h.charAt(1) === '/' || a.hasAttribute('data-pwl-loc')) return;
    var p = h;
    if (!ALLOW.test(p)) { var q = p.replace(LOCALE, ''); if (q !== p && ALLOW.test(q)) p = q; else return; }
    var n = root + p.slice(1);
    if (n !== h) a.setAttribute('href', n);
    a.setAttribute('data-pwl-loc', '');
  }
  function run(ctx) {
    var boxes = (ctx || document).querySelectorAll(SCOPE);
    for (var i = 0; i < boxes.length; i++) {
      var as = boxes[i].querySelectorAll('a[href^="/"]');
      for (var j = 0; j < as.length; j++) fix(as[j]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { run(); }); else run();
  if (window.MutationObserver) {
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(run, 50); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
